import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue-demi';
import { useCdnImg } from '@webplatform/cdn-image';
import { AbTitle, AbIcon, AbVideo } from '../../../ui';

interface Props {
  name?: string | null;
  text?: string | null;
  image?: string | null;
  title?: string | null;
  video?: string | null;
  button: {
    text: string;
    isVisible?: boolean | null;
    isVideoOpener?: boolean | null;
    link?: string | null;
    target?: string | null;
  };
  videoId?: string | null;
  features: {
    icon: string;
    text?: string | null;
    title: string;
    iconMobile: string;
  }[];
  featuresText?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionVideoTabsSlideMobile',
  props: {
    name: null,
    text: null,
    image: null,
    title: null,
    video: null,
    button: null,
    videoId: null,
    features: null,
    featuresText: null
  },
  setup(__props: any) {


const { generateUrl } = useCdnImg();

const isPlaying = ref(false);

const playVideo = () => {
  isPlaying.value = true;
};

return { __sfc: true,generateUrl, isPlaying, playVideo, AbTitle, AbIcon, AbVideo }
}

})